import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconShoppingBag3"><Path fillRule="evenodd" clipRule="evenodd" d="M7.5 3C7.22386 3 7 3.22386 7 3.5V7H3.5C3.22386 7 3 7.22386 3 7.5V18.5C3 19.8807 4.11929 21 5.5 21H18.5C19.8807 21 21 19.8807 21 18.5V7.5C21 7.22386 20.7761 7 20.5 7H17V3.5C17 3.22386 16.7761 3 16.5 3H7.5ZM16 7V11.5C16 11.7761 16.2239 12 16.5 12C16.7761 12 17 11.7761 17 11.5V7H16ZM8 7V11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5V7H8ZM8 7H16V4H8V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag3;
